import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { ValuableObjectsMetadataComponentAbstract } from '../../metadata-components/valuable-objects-metadata/valuable-objects-metadata.component.abstract';

@Component({
  selector: 'app-valuable-objects-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, IconsModule, PdfViewerModalComponent],
  templateUrl: './valuable-objects-metadata-v2.component.html',
})
export class ValuableObjectsMetadataV2Component extends ValuableObjectsMetadataComponentAbstract {}
